import axios from 'axios'
const SimfoniURL = process.env.VUE_APP_SIMFONI
const HarmoniURL = process.env.VUE_APP_SERVICEURL

export default {
    name: 'karyawan',
    state: {
        karyawan: [],
        karyawanBawahan: [],
    },
    getters: {
        getKaryawan: state => {
            return state.karyawan
        },
        getKaryawanBawahan: state => {
            return state.karyawanBawahan
        }
    },
    mutations: {
        KARYAWAN: (state, payload) => {
            state.karyawan = payload
        },
        KARYAWANBAWAHAN: (state, payload) => {
            state.karyawanBawahan = payload
        },
    },
    actions: {
        FETCH_KARYAWAN(store, payload) {
            return axios({
                method: 'get',
                url: SimfoniURL + 'user/allkaryawan',
                params: {
                    tlc: payload
                },
                auth: {
                    username: store.rootState.auth.auth.username,
                    password: store.rootState.auth.auth.password
                },
                headers: {
                    'X-API-KEY': store.rootState.auth.auth.apikey
                }
            }).then(response => {
                store.commit('KARYAWAN', response.data.data)
            }).catch(err => {
                return err
            })
        },
        FETCH_KARYAWANBAWAHAN(store) {
            return axios({
                method: 'get',
                url: HarmoniURL + 'master_karyawan/bawahan',
                params: {
                    tlc: store.rootState.auth.auth.username
                },
                auth: {
                    username: store.rootState.auth.auth.username,
                    password: store.rootState.auth.auth.password
                },
                headers: {
                    'X-API-KEY': store.rootState.auth.auth.apikey
                }
            }).then(response => {
                store.commit('KARYAWANBAWAHAN', response.data.data)
            }).catch(err => {
                return err
            })
        }
    }
}
